import { TextBadge } from '#/components/Badge/TextBadge';
import { useI18n } from '#/i18n/hooks/useI18n';
import { SEARCH_COMMON_REFINEMENT_LABELS } from '#/modules/search/constants/refinements/searchCommonRefinementTypes';
import { useSearchFacetSelectedValues } from '#/modules/search/hooks/facets/useSearchFacetSelectedValues';
import type { SearchRefinementVariant } from '#/modules/search/types/SearchRefinementVariant';
import { ORG_TYPE_CHECKBOX_OPTIONS } from '#/utils/constants/general/orgTypes';

import { SearchFacetAccordionItem } from './AccordionItem/SearchFacetAccordionItem';
import { SearchFacetDropdown } from './Dropdown/SearchFacetDropdown';
import { SearchFacetCheckboxOptions } from './Options/SearchFacetCheckboxOptions';

type Props = {
  variant: SearchRefinementVariant;
};
export function OrgTypeFacet({ variant }: Props) {
  const { i18n } = useI18n();

  const selectedFacetValues = useSearchFacetSelectedValues('orgType');

  const FacetVariant =
    variant === 'accordion' ? SearchFacetAccordionItem : SearchFacetDropdown;

  return (
    <FacetVariant
      facetType="orgType"
      icon="building"
      label={
        <>
          {SEARCH_COMMON_REFINEMENT_LABELS(i18n).orgType}{' '}
          <TextBadge content={selectedFacetValues.length} />
        </>
      }
    >
      <SearchFacetCheckboxOptions
        facetType="orgType"
        initialValue={selectedFacetValues}
        options={ORG_TYPE_CHECKBOX_OPTIONS(i18n)}
      />
    </FacetVariant>
  );
}
